<div
  class="star-with-number"
  [style.height.rem]="iconSize"
>
  <div class="star-icon">
    <svg-icon
      [src]="icon"
      [svgStyle]="{ 'height.rem': iconSize }"
    ></svg-icon>
  </div>
  <div
    class="number"
    [style.color]="numberColor"
  >
    {{ number }}
  </div>
</div>
